import { gql } from '@apollo/client';

export const TOGGLE_ACCOUNT_BLOCK = gql`
    mutation toggleAccountBlock($accountId: ID!) {
        toggleAccountBlock(accountId: $accountId)
    }
`;
